import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL + "/offers";

const setTokenAllHeaders = async () => {
    const token = localStorage.getItem("adminToken");
    axios.defaults.headers.common["Authorization"] = token;
};

const getAllOffers = async ({
    limit = 10,
    page = 0,
    status = null,
    sortModel = [],
    filterModel = {}
}) => {
    try {
        await setTokenAllHeaders();

        const sendStatus = status === 0 ? null : status;
        const search = filterModel?.quickFilterValues?.[0] || null;

        const params = {
            limit,
            page,
            sendStatus,
            search,
            sort: JSON.stringify(sortModel || []),
            items: JSON.stringify(filterModel?.items || []),
            offerType: filterModel?.offerType || null,
            offerTypes: JSON.stringify(filterModel?.offerTypes || []),
            createdDate: filterModel?.createdDate ? JSON.stringify(filterModel.createdDate) : null,
        };

        const response = await axios.get(`${BASE_URL}/get`, { params });
        return response.data;
    } catch (error) {
        console.error("Error fetching offers list :", error);
        throw error;
    }
};
const getOfferDetails = async ({
    offerId = null,
    limit = 10,
    page = 0,
    status = null,
    sortModel = [],
    filterModel = {}
}) => {
    try {
        await setTokenAllHeaders();
        // Handle status nullification
        const sendStatus = status === 0 ? null : status;
        // Extract 'quickFilterValues' if it exists in filterModel
        const search = filterModel?.quickFilterValues?.[0] || null;
        // Prepare the parameters for the API call
        // console.log(filterModel, "filterModel"); 
        const params = {
            limit,
            page,
            sendStatus,
            search,
            sort: sortModel,
            ...filterModel // Spread any additional filters from filterModel
        };

        // API call to fetch contacts
        const response = await axios.get(`${BASE_URL}/details/${offerId}/`, { params });

        return response.data;
    } catch (error) {
        console.error("Error fetching offers list :", error);
        throw error;
    }
};


const uploadOffers = async (params) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.post(`${BASE_URL}/upload/`, params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error(`Error upload offer file:`, error);
        throw error;
    }
};
const syncOffers = async (params) => {
    try {
        await setTokenAllHeaders();
        let dt = { ...params }
        const response = await axios.post(`${BASE_URL}/discount/sync`, dt);
        return response.data;
    } catch (error) {
        console.error(`Error upload offer file:`, error);
        throw error;
    }
};


const updateOfferProductStatus = async (params) => {
    try {
        await setTokenAllHeaders();
        const dt = { ...params };
        const response = await axios.post(`${BASE_URL}/products/status/`, dt);
        return response.data;
    } catch (error) {
        console.error(`Error updating offer products status:`, error);
        throw error;
    }
};
const updateOfferBranchStatus = async (params) => {
    try {
        await setTokenAllHeaders();
        const dt = { ...params };
        const response = await axios.post(`${BASE_URL}/branch/status/`, dt);
        return response.data;
    } catch (error) {
        console.error(`Error updating offer products status:`, error);
        throw error;
    }
};
const updateOfferStatus = async (params) => {
    try {
        await setTokenAllHeaders();
        const dt = { ...params };
        const response = await axios.post(`${BASE_URL}/status/`, dt);
        return response.data;
    } catch (error) {
        console.error(`Error updating offer products status:`, error);
        throw error;
    }
};

const getManualOffer = async (offerId) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.get(`${BASE_URL}/manual/${offerId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching manual offer:", error);
        throw error;
    }
};

const createManualOffer = async (payload) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.post(`${BASE_URL}/manual`, payload);
        return response.data;
    } catch (error) {
        console.error("Error creating manual offer:", error);
        throw error;
    }
};

const updateManualOffer = async (offerId, payload) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.put(`${BASE_URL}/manual/${offerId}`, payload);
        return response.data;
    } catch (error) {
        console.error("Error updating manual offer:", error);
        throw error;
    }
};

const offerAPI = {
    uploadOffers,
    syncOffers,
    getAllOffers,
    getOfferDetails,
    updateOfferProductStatus,
    updateOfferBranchStatus,
    updateOfferStatus,
    getManualOffer,
    createManualOffer,
    updateManualOffer
};

export default offerAPI